import { render, staticRenderFns } from "./FailedApplicants.vue?vue&type=template&id=096b556a"
import script from "./FailedApplicants.vue?vue&type=script&lang=js"
export * from "./FailedApplicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports